import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SmartCampusDashboard from "./components/SmartCampusDashboard";
import StaffManagement from "./components/StaffManagement";
import AdmissionPage from "./components/AdmissionPage";
import StudentProfile from "./components/StudentProfile";
import SchoolLoginPage from "./components/SchoolLoginPage";
import Parentlogin from './components/Parentlogin';
import ParentsDashboard from './components/ParentsDashboard';
import TimeTable from "./components/TimeTable";
import Fee from "./components/Fee";
import LogBook from "./components/LogBook";
import StaffDailyAttendance from "./components/StaffDailyAttendance";
import StaffAttendance from "./components/StaffAttendance";
import WorkersPage from "./components/WorkersPage";
import AdminCircular from './components/admincircular';
import PrincipalView from './components/PrincipalView';
import DonationManagement from './components/DonationManagement';
import SalaryManagement from "./components/SalaryManagement";
import WorkerAttendance from "./components/WorkerAttendance";
import WorkerAttendancePage from "./components/WorkerAttendancePage";
import Login from "./components/supervoicerlogin";
// App.js la
import IdCardGenerator from "./components/Idcardgenerator";
import AdminPrincipalMessages from "./components/AdminPrincipalMessages";
import HostelManagement from './components/HostelManagement';
import GirlsHostelManagement from "./components/GirlsHostelManagement";
import BoysHostelManagement from "./components/BoysHostelManagement";
import HostelLoginPage from "./components/HostelLoginPage";
         import StaffAnalysis from "./components/StaffAnalysis";
         import StudentAnalysis from "./components/StudentAnalysis";
import StudentTransfer from "./components/StudentTransfer";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/principal-view" element={<PrincipalView />} />
        <Route path="/dashboard" element={<SmartCampusDashboard />} />
        <Route path="/staff" element={<StaffManagement />} />
        <Route path="/admin" element={<AdmissionPage />} />
        <Route path="/staffdetails" element={<StudentProfile/>}/>
        <Route path="/" element={<SchoolLoginPage/>}/>
        <Route path="/parentlogin" element={<Parentlogin/>}/>
        <Route path="/parent-dashboard" element={<ParentsDashboard />} />
        <Route path="/timetable" element={<TimeTable />} />
        <Route path="/fees" element={<Fee />} />
        <Route path="/logbook" element={<LogBook />} />
        <Route path="/staff-daily-attendance" element={<StaffDailyAttendance />} />
        <Route path="/staff-attendance" element={<StaffAttendance />} />
        <Route path="/workers" element={<WorkersPage />} />  
        <Route path="/admin-circular" element={<AdminCircular />} />
        <Route path="/donations" element={<DonationManagement />} />
        <Route path="/salary" element={<SalaryManagement />} />
        <Route path="/attendance" element={<WorkerAttendance />} />
        <Route path="/worker-attendance-page" element={<WorkerAttendancePage />} />
        <Route path="/supervoicerlogin" element={<Login />} />
        <Route path="/id-cards" element={<IdCardGenerator />} />
        <Route path="/admin-principal-messages" element={<AdminPrincipalMessages />} />
        <Route path="/hostel-management" element={<HostelManagement />} />
        <Route path="/hostel-boys" element={<BoysHostelManagement />} />
        <Route path="/hostel-girls" element={<GirlsHostelManagement />} />
         <Route path="/hostel-login" element={<HostelLoginPage />} />
<Route path="/staff-analysis" element={<StaffAnalysis />} />
<Route path="/student-analysis" element={<StudentAnalysis />} />
<Route path="/student-transfer" element={<StudentTransfer />} />
      </Routes>
    </Router>
  );
}

export default App;